(function () {
  var roots = document.querySelectorAll("[data-ls-residential-shade-finder]");
  if (!roots.length) return;

  roots.forEach(initFinder);

  function initFinder(root) {
    if (root.dataset.ready === "true") return;
    root.dataset.ready = "true";

    var q = function (selector) { return root.querySelector(selector); };
    var qa = function (selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); };
    var form = q("[data-hsf-search]");
    var postalInput = q(".ls-hsf__postal-input");
    var status = q("[data-hsf-status]");
    var matchCard = q("[data-hsf-match]");
    var matchKicker = q("[data-hsf-match-kicker]");
    var matchTitle = q("[data-hsf-match-title]");
    var matchMeta = q("[data-hsf-match-meta]");
    var matchNote = q("[data-hsf-match-note]");
    var propertyWrap = q("[data-hsf-property-wrap]");
    var propertySelect = q("[data-hsf-property-select]");
    var hdbCheckWrap = q("[data-hsf-hdb-check-wrap]");
    var hdbCheck = q("[data-hsf-hdb-check]");
    var matchActions = q("[data-hsf-match-actions]");
    var startButton = q("[data-hsf-start]");
    var noMatch = q("[data-hsf-no-match]");
    var noMatchCopy = q("[data-hsf-no-match-copy]");
    var manualName = q("[data-hsf-manual-name]");
    var homeTypeCopy = q("[data-hsf-home-type-copy]");
    var addressChips = qa("[data-hsf-address-chip]");
    var layoutNote = q("[data-hsf-layout-note]");
    var homeGrid = q("[data-hsf-home-type-grid]");
    var planPreview = q("[data-hsf-plan-preview]");
    var homeValidation = q("[data-hsf-home-validation]");
    var roomCount = q("[data-hsf-room-count]");
    var roomValidation = q("[data-hsf-room-validation]");
    var roomNext = q('[data-hsf-next="4"]');
    var homeNext = q('[data-hsf-next="3"]');
    var summary = q("[data-hsf-summary]");
    var leadSummary = q("[data-hsf-lead-summary]");
    var leadFormHost = q("[data-hsf-form-host]");
    var leadContactForm = leadFormHost && leadFormHost.querySelector("form");
    var leadSubmitButton = leadFormHost && leadFormHost.querySelector("[data-hsf-submit-button]");
    var leadSubmitLabel = leadFormHost && leadFormHost.querySelector("[data-hsf-submit-label]");
    var leadSubmitStatus = leadFormHost && leadFormHost.querySelector("[data-hsf-form-status]");
    var leadCaptchaPreparationAttempted = false;
    var previewForm = q("[data-hsf-preview-form]");
    var recommendations = q("[data-hsf-recommendations]");
    var whatsappLinks = qa("[data-hsf-whatsapp]");
    var contactLinks = qa("[data-hsf-contact-link]");

    var typeNames = {
      condo: "Condominium / apartment",
      EC: "Executive condominium",
      landed: "Landed home",
      HDB: "HDB building"
    };
    var roomNames = {
      balcony: "Balcony / outdoor opening",
      living: "Living or dining room",
      bedroom: "Bedroom",
      study: "Study or work area",
      kitchen: "Kitchen",
      other: "Another room or window"
    };
    var preferenceNames = {
      heat: "Reduce heat and glare",
      privacy: "More privacy",
      darkness: "A darker room",
      weather: "Shelter from wind and rain",
      motorised: "Motorised operation"
    };
    var products = {
      zip: {
        title: "Outdoor Zip Blinds",
        href: "/collections/outdoor-zip-blinds",
        link: "Explore Outdoor Zip Blinds",
        copy: "A strong starting point for balconies and exposed outdoor openings. Longshade can confirm the fixing points, opening dimensions and weather exposure before recommending a system."
      },
      blinds: {
        title: "Indoor Window Blinds",
        href: "/collections/window-blinds",
        link: "Explore Window Blinds",
        copy: "Compare roller, zebra and other indoor blind styles for light control and privacy. The right fabric and operation depend on how each room is used."
      },
      curtains: {
        title: "Made-to-measure Curtains",
        href: "/collections/curtains",
        link: "Explore Curtains",
        copy: "A flexible choice for living areas and bedrooms where you want to balance daylight, privacy and a softer finish. Fabric coverage can be discussed during your consultation."
      }
    };

    var state = {
      catalogPromise: null,
      recordsByPostal: new Map(),
      hdbAreas: [],
      floorPlans: [],
      currentRecords: [],
      currentRecord: null,
      currentCode: "",
      selectedHome: null,
      selectedRooms: new Set(),
      selectedPreferences: new Set(),
      recommendedProducts: [],
      activeStep: 1
    };

    function element(tag, className, text) {
      var node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined && text !== null) node.textContent = String(text);
      return node;
    }

    function setStatus(message, isError) {
      status.textContent = message || "";
      status.classList.toggle("is-error", Boolean(isError));
    }

    function setValidation(node, message, isError) {
      node.textContent = message || "";
      node.classList.toggle("is-error", Boolean(isError));
    }

    function decodeRecord(row) {
      var type = String(row[1] || "");
      return {
        postalCode: String(row[0] || "").padStart(6, "0"),
        type: type,
        propertyType: typeNames[type] || type,
        projectName: String(row[2] || ""),
        blockNo: String(row[3] || ""),
        unitCount: row[4] === null || row[4] === "" ? null : Number(row[4]),
        status: String(row[5] || "existing")
      };
    }

    function loadCatalog() {
      if (state.catalogPromise) return state.catalogPromise;
      state.catalogPromise = Promise.all([
        fetch(root.dataset.indexUrl).then(function (response) {
          if (!response.ok) throw new Error("The residential index could not be loaded.");
          return response.json();
        }),
        fetch(root.dataset.hdbAreaUrl).then(function (response) {
          if (!response.ok) return [];
          return response.json();
        }).catch(function () { return []; }),
        fetch(root.dataset.floorplansUrl).then(function (response) {
          if (!response.ok) return [];
          return response.json();
        }).catch(function () { return []; })
      ]).then(function (data) {
        if (!Array.isArray(data[0])) throw new Error("The residential index has an unexpected format.");
        data[0].forEach(function (row) {
          if (!Array.isArray(row)) return;
          var record = decodeRecord(row);
          if (!/^\d{6}$/.test(record.postalCode)) return;
          if (!state.recordsByPostal.has(record.postalCode)) state.recordsByPostal.set(record.postalCode, []);
          state.recordsByPostal.get(record.postalCode).push(record);
        });
        state.hdbAreas = Array.isArray(data[1]) ? data[1] : [];
        state.floorPlans = Array.isArray(data[2]) ? data[2] : [];
        return true;
      });
      return state.catalogPromise;
    }

    function propertyLabel(record) {
      var prefix = record.status === "uc" ? "Under construction · " : "";
      if (record.type === "HDB") return prefix + "HDB Block " + (record.blockNo || "");
      if (record.projectName) return prefix + record.projectName + " · " + (record.propertyType || "Residential address");
      if (record.type === "landed") return prefix + "Private landed home";
      if (record.status === "manual") return record.projectName || "My home";
      return prefix + (record.propertyType || "Residential address");
    }

    function propertyMeta(record) {
      var pieces = ["Postal code " + record.postalCode];
      if (record.blockNo && record.type !== "HDB") pieces.unshift("Block " + record.blockNo);
      if (record.status === "uc") pieces.push("Address is listed for a building under construction");
      else if (record.status === "manual") pieces.push("Property details provided by you");
      else if (record.type === "HDB") pieces.push("HDB building record · matched to your postal code");
      else pieces.push("Residential address match");
      return pieces.join(" · ");
    }

    function currentAddressSummary() {
      if (!state.currentRecord) return "";
      return propertyLabel(state.currentRecord) + " · " + state.currentRecord.postalCode;
    }

    function updateAddressChips() {
      var text = currentAddressSummary();
      addressChips.forEach(function (chip) { chip.textContent = text; });
    }

    function allowedPlan(plan) {
      return Boolean(plan &&
        (plan.rightsStatus === "cleared" || plan.rightsStatus === "authorized") &&
        (plan.imageUrl || plan.fileUrl));
    }

    function matchingPlans(record) {
      var projectName = String(record.projectName || "").trim().toLowerCase();
      return state.floorPlans.filter(function (plan) {
        var postalCodes = Array.isArray(plan.postalCodes) ? plan.postalCodes.map(String) : [];
        var postalMatch = String(plan.postalCode || "") === record.postalCode || postalCodes.indexOf(record.postalCode) !== -1;
        var nameMatch = projectName && String(plan.projectName || "").trim().toLowerCase() === projectName;
        var typeMatch = record.type === "unknown" || !plan.propertyType || plan.propertyType === record.type;
        return Boolean((postalMatch || nameMatch) && typeMatch && allowedPlan(plan));
      });
    }

    function safeUrl(value, allowLocalHttp) {
      if (!value) return "";
      try {
        var base = root.dataset.siteBaseUrl || window.location.origin;
        var url = new URL(value, base);
        if (url.protocol !== "https:" && url.protocol !== "http:") return "";
        if (!allowLocalHttp && url.protocol === "http:" && url.origin !== window.location.origin) return "";
        return url.href;
      } catch (error) {
        return "";
      }
    }

    function productUrl(route) {
      return safeUrl(route, true);
    }

    function showRecord(record) {
      state.currentRecord = record;
      state.selectedHome = null;
      state.currentCode = record.postalCode;
      resetRoomSelections();
      matchCard.hidden = false;
      noMatch.hidden = true;
      matchKicker.textContent = record.status === "manual" ? "Property details" : "Address match";
      matchTitle.textContent = propertyLabel(record);
      matchMeta.textContent = propertyMeta(record);
      matchNote.textContent = record.type === "HDB"
        ? "HDB source records identify a block and do not confirm your flat’s layout. Continue to choose your flat type."
        : record.status === "uc"
          ? "This postal code is listed for a building under construction. We’ll use your selection as a starting point and confirm the project details with you."
          : record.status === "manual"
            ? "We’ll use the project or estate name you entered and your selected home type to prepare the suggestions."
            : "We use this address to look for a verified layout. If none is available, you can still choose an approximate home type.";
      hdbCheckWrap.hidden = true; /* 20261016: HDB confirmation checkbox step removed per user request */
      hdbCheck.checked = true;
      matchActions.hidden = false;
      startButton.disabled = false;
      updateAddressChips();
    }

    function resetRoomSelections() {
      qa("[data-hsf-room-choice], [data-hsf-preference]").forEach(function (input) {
        input.checked = false;
      });
      state.selectedRooms.clear();
      state.selectedPreferences.clear();
      syncChoiceLabels();
    }

    function setPropertyChoices(records) {
      state.currentRecords = records;
      propertySelect.innerHTML = "";
      if (records.length > 1) {
        records.forEach(function (record, index) {
          var option = element("option", "", propertyLabel(record));
          option.value = String(index);
          propertySelect.appendChild(option);
        });
        propertyWrap.hidden = false;
      } else {
        propertyWrap.hidden = true;
      }
      showRecord(records[0]);
    }

    function showNoMatch(message) {
      matchCard.hidden = true;
      noMatch.hidden = false;
      noMatchCopy.textContent = message || "We couldn’t match this postal code in the current residential index. You can still continue by entering your project or estate name.";
      matchActions.hidden = true;
      propertyWrap.hidden = true;
      setStatus("You can continue with the address even if it is not in the local index.", false);
    }

    function formatHomeSummary(home) {
      return home && home.summary ? home.summary : (home ? home.label : "Not selected");
    }

    function makeChoiceCard(option, index) {
      var button = element("button", "ls-hsf__choice-card");
      button.type = "button";
      button.setAttribute("aria-pressed", "false");
      button.dataset.hsfChoiceKey = option.key;

      if (option.plan && option.plan.imageUrl) {
        var imageUrl = safeUrl(option.plan.imageUrl, false);
        if (imageUrl) {
          var image = element("img", "ls-hsf__choice-card-image");
          image.src = imageUrl;
          image.alt = option.plan.imageAlt || (option.plan.projectName + " " + (option.plan.unitType || "unit") + " floor plan");
          image.loading = "lazy";
          button.appendChild(image);
        }
      }

      var mark = element("span", "ls-hsf__choice-mark", "✓");
      mark.setAttribute("aria-hidden", "true");
      button.appendChild(mark);
      var copy = element("span", "ls-hsf__choice-card-copy");
      copy.appendChild(element("strong", "", option.label));
      if (option.description) copy.appendChild(element("small", "", option.description));
      if (option.detail) copy.appendChild(element("small", "", option.detail));
      button.appendChild(copy);

      button.addEventListener("click", function () {
        state.selectedHome = option;
        qa("[data-hsf-choice-key]").forEach(function (card) {
          var selected = card === button;
          card.classList.toggle("is-selected", selected);
          card.setAttribute("aria-pressed", selected ? "true" : "false");
        });
        renderPlanPreview(option);
        homeNext.disabled = false;
        setValidation(homeValidation, "", false);
      });
      return button;
    }

    function renderPlanPreview(option) {
      planPreview.innerHTML = "";
      if (!option || !option.plan) return;
      var plan = option.plan;
      var figure = element("figure", "ls-hsf__plan-figure");
      var imageUrl = safeUrl(plan.imageUrl, false);
      if (imageUrl) {
        var image = element("img");
        image.src = imageUrl;
        image.alt = plan.imageAlt || (plan.projectName + " " + (plan.unitType || "unit") + " floor plan");
        image.loading = "lazy";
        figure.appendChild(image);
      }
      var caption = [plan.projectName, plan.unitType, plan.bedrooms ? plan.bedrooms + " bedroom" : "", plan.floorAreaSqft ? plan.floorAreaSqft + " sqft" : "", plan.floorAreaSqm ? plan.floorAreaSqm + " sqm" : ""]
        .filter(Boolean).join(" · ");
      if (caption) figure.appendChild(element("figcaption", "", caption));
      if (plan.fileUrl) {
        var documentUrl = safeUrl(plan.fileUrl, false);
        if (documentUrl) {
          var documentNote = element("span", "ls-hsf__plan-document");
          var link = element("a", "", "Open the official floor-plan document");
          link.href = documentUrl;
          link.target = "_blank";
          link.rel = "noopener noreferrer";
          documentNote.appendChild(link);
          figure.appendChild(documentNote);
        }
      }
      planPreview.appendChild(figure);
    }

    function addApproximateHomeChoices(record) {
      var isHdb = record.type === "HDB";
      if (isHdb) {
        layoutNote.textContent = "HDB flat types are shown with recent Singapore resale-area references. These are not this block’s official floor plan or the measured area of your flat.";
        homeTypeCopy.textContent = "Choose your HDB flat type. If you are unsure, select ‘Not sure’ and we’ll help confirm it.";
        var available = state.hdbAreas;
        if (available.length) {
          available.forEach(function (area, index) {
            var type = String(area.flat_type || "HDB flat");
            var areaText = area.median_floor_area_sqm ? "Median " + area.median_floor_area_sqm + " m²" : "Area reference unavailable";
            var rangeText = area.middle_50_low_sqm && area.middle_50_high_sqm
              ? "Middle half: " + area.middle_50_low_sqm + "–" + area.middle_50_high_sqm + " m²"
              : "Recent Singapore resale reference";
            var option = {
              key: "hdb-" + index,
              label: type,
              description: areaText,
              detail: rangeText + (area.transaction_count ? " · " + Number(area.transaction_count).toLocaleString() + " sales" : ""),
              summary: type + (area.median_floor_area_sqm ? " · " + area.median_floor_area_sqm + " m² resale median (reference only)" : " · area not confirmed")
            };
            homeGrid.appendChild(makeChoiceCard(option, index));
          });
        } else {
          ["2 ROOM", "3 ROOM", "4 ROOM", "5 ROOM", "EXECUTIVE", "Not sure"].forEach(function (type, index) {
            homeGrid.appendChild(makeChoiceCard({
              key: "hdb-fallback-" + index,
              label: type,
              description: "Approximate flat type",
              detail: "Select the closest option; no block-specific floor plan is available.",
              summary: type + " · approximate selection"
            }, index));
          });
        }
        homeGrid.appendChild(makeChoiceCard({
          key: "hdb-unsure",
          label: "Not sure",
          description: "I’m not sure which HDB type I have.",
          detail: "Longshade can help confirm it during your consultation.",
          summary: "HDB type not sure"
        }, 99));
        return;
      }

      layoutNote.textContent = "There is no rights-cleared, project-specific floor plan for this address in the local catalogue yet. Choose an approximate bedroom count to continue; it is not an official unit type or floor area.";
      homeTypeCopy.textContent = "Choose the closest bedroom count, or select ‘Not sure’. This helps us tailor the conversation without pretending it is a verified floor plan.";
      [
        { key: "bed-1", label: "Studio / 1 bedroom", description: "A compact home or studio", summary: "Studio / 1 bedroom · approximate" },
        { key: "bed-2", label: "2 bedrooms", description: "A two-bedroom home", summary: "2 bedrooms · approximate" },
        { key: "bed-3", label: "3 bedrooms", description: "A three-bedroom home", summary: "3 bedrooms · approximate" },
        { key: "bed-4", label: "4+ bedrooms", description: "A larger family home", summary: "4+ bedrooms · approximate" },
        { key: "bed-unsure", label: "Not sure", description: "I’ll confirm this with Longshade.", summary: "Bedroom count not sure" }
      ].forEach(function (option, index) {
        option.detail = "Approximate selection · no project-specific layout or area is available.";
        homeGrid.appendChild(makeChoiceCard(option, index));
      });
    }

    function renderHomeTypes() {
      homeGrid.innerHTML = "";
      planPreview.innerHTML = "";
      homeNext.disabled = true;
      state.selectedHome = null;
      setValidation(homeValidation, "", false);
      var record = state.currentRecord;
      if (!record) return;

      var plans = matchingPlans(record);
      if (plans.length) {
        layoutNote.textContent = "The layouts below have a verified source and permission to display. Select your unit type to view its plan.";
        homeTypeCopy.textContent = "Choose your unit type to view the verified floor-plan drawing and available area details.";
        plans.forEach(function (plan, index) {
          var labelParts = [plan.unitType || "Verified unit type"];
          if (plan.bedrooms) labelParts.push(plan.bedrooms + " bedroom");
          if (plan.floorAreaSqft) labelParts.push(plan.floorAreaSqft + " sqft");
          if (plan.floorAreaSqm) labelParts.push(plan.floorAreaSqm + " sqm");
          homeGrid.appendChild(makeChoiceCard({
            key: "verified-" + index,
            label: plan.unitType || "Verified unit type",
            description: labelParts.slice(1).join(" · ") || "Official project layout",
            detail: "Verified project floor plan",
            summary: labelParts.join(" · "),
            plan: plan
          }, index));
        });
      } else {
        addApproximateHomeChoices(record);
      }
    }

    function showStep(step, shouldScroll) {
      state.activeStep = step;
      qa("[data-hsf-step-item]").forEach(function (item) {
        var itemStep = Number(item.dataset.hsfStepItem);
        item.classList.toggle("is-current", itemStep === step);
        item.classList.toggle("is-complete", itemStep < step);
        if (itemStep === step) item.setAttribute("aria-current", "step");
        else item.removeAttribute("aria-current");
      });
      qa("[data-hsf-panel]").forEach(function (panel) {
        panel.hidden = Number(panel.dataset.hsfPanel) !== step;
      });
      if (step === 5 && !q("[data-hsf-posted-success], [data-hsf-submission-error]")) {
        renderLeadSummary();
        prepareLeadCaptcha();
      }
      syncSelectionField();
      if (!shouldScroll) return;
      var target = step === 1 ? q(".ls-hsf__postal-card") : q('[data-hsf-panel="' + step + '"]');
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    function prepareLeadCaptcha() {
      if (!leadContactForm || leadCaptchaPreparationAttempted) return;
      var captcha = window.Shopify && window.Shopify.captcha;
      if (!captcha || typeof captcha.protect !== "function") return;
      leadCaptchaPreparationAttempted = true;
      try {
        captcha.protect(leadContactForm);
      } catch (error) {
        return;
      }
    }

    function setPropertyMatch(records, code) {
      state.currentCode = code;
      setPropertyChoices(records);
      matchActions.hidden = false;
      setStatus(records.length === 1 ? "We found this residential address. Continue to choose your home type." : "Several records use this postal code. Choose the correct building, then continue.", false);
    }

    async function search(event) {
      event.preventDefault();
      var code = postalInput.value.trim();
      matchCard.hidden = true;
      noMatch.hidden = true;
      propertyWrap.hidden = true;
      matchActions.hidden = true;
      state.currentRecords = [];
      state.currentRecord = null;
      state.currentCode = "";
      state.selectedHome = null;
      resetRoomSelections();
      setValidation(homeValidation, "", false);
      showStep(1, false);
      if (!/^\d{6}$/.test(code)) {
        setStatus("Enter a valid 6-digit Singapore postal code.", true);
        postalInput.focus();
        return;
      }

      state.currentCode = code;
      setStatus("Searching residential records…", false);
      try {
        await loadCatalog();
        var found = state.recordsByPostal.get(code) || [];
        if (!found.length) {
          showNoMatch("We couldn’t match this postal code in the current residential index. Enter your project or estate name to continue manually.");
          return;
        }
        setPropertyMatch(found, code);
      } catch (error) {
        showNoMatch("We couldn’t load the local address index just now. You can still continue by entering your project or estate name.");
        setStatus("Address data could not be loaded. Manual selection is available below.", true);
      }
    }

    function continueManually() {
      var code = postalInput.value.trim();
      if (!/^\d{6}$/.test(code)) {
        setStatus("Enter a valid 6-digit Singapore postal code first.", true);
        postalInput.focus();
        return;
      }
      var record = {
        postalCode: code,
        type: "unknown",
        propertyType: "Residential home",
        projectName: manualName.value.trim(),
        blockNo: "",
        unitCount: null,
        status: "manual"
      };
      state.currentRecords = [record];
      propertyWrap.hidden = true;
      showRecord(record);
      setStatus("Ready. Choose an approximate home type to continue.", false);
    }

    function syncChoiceLabels() {
      qa("[data-hsf-room-choice]").forEach(function (input) {
        input.closest(".ls-hsf__room-card").classList.toggle("is-selected", input.checked);
      });
      qa("[data-hsf-preference]").forEach(function (input) {
        input.closest(".ls-hsf__preference").classList.toggle("is-selected", input.checked);
      });
      state.selectedRooms = new Set(qa("[data-hsf-room-choice]:checked").map(function (input) { return input.value; }));
      state.selectedPreferences = new Set(qa("[data-hsf-preference]:checked").map(function (input) { return input.value; }));
      var count = state.selectedRooms.size;
      roomCount.textContent = count
        ? count + (count === 1 ? " room selected." : " rooms selected.") + " Choose what matters most, then view your suggestions."
        : "Select at least one room to see suggestions.";
      roomNext.disabled = count === 0;
      if (count) setValidation(roomValidation, "", false);
    }

    function selectedValues(set, lookup) {
      return Array.from(set).map(function (key) { return lookup[key]; }).filter(Boolean);
    }

    function roomProductKeys(room) {
      if (room === "balcony") return ["zip"];
      if (room === "bedroom" || room === "living" || room === "other") return ["curtains", "blinds"];
      return ["blinds"];
    }

    function productReason(key, roomLabels, preferences) {
      var reason = products[key].copy;
      if (preferences.length) reason += " Your priorities: " + preferences.join(", ").toLowerCase() + ".";
      if (key === "blinds" && roomLabels.indexOf(roomNames.kitchen) !== -1) {
        reason += " For kitchens, ask us to confirm that the material suits heat, moisture and cleaning needs.";
      }
      return reason;
    }

    function renderSummary() {
      summary.innerHTML = "";
      var selectedRooms = selectedValues(state.selectedRooms, roomNames);
      var selectedPreferences = selectedValues(state.selectedPreferences, preferenceNames);
      var items = [
        ["Address", currentAddressSummary()],
        ["Home type", formatHomeSummary(state.selectedHome)],
        ["Rooms", selectedRooms.join(", ")]
      ];
      items.forEach(function (item) {
        var cell = element("div", "ls-hsf__summary-item");
        cell.appendChild(element("small", "", item[0]));
        cell.appendChild(element("strong", "", item[1] || "Not selected"));
        summary.appendChild(cell);
      });
      if (selectedPreferences.length) {
        var pref = element("div", "ls-hsf__summary-item");
        pref.appendChild(element("small", "", "Priorities"));
        pref.appendChild(element("strong", "", selectedPreferences.join(", ")));
        summary.appendChild(pref);
      }
    }

    function renderRecommendations() {
      recommendations.innerHTML = "";
      var roomLabels = selectedValues(state.selectedRooms, roomNames);
      var preferenceLabels = selectedValues(state.selectedPreferences, preferenceNames);
      var byProduct = new Map();
      Array.from(state.selectedRooms).forEach(function (room) {
        roomProductKeys(room).forEach(function (key) {
          if (!byProduct.has(key)) byProduct.set(key, []);
          byProduct.get(key).push(roomNames[room]);
        });
      });

      state.recommendedProducts = Array.from(byProduct.keys());
      byProduct.forEach(function (matchedRooms, key) {
        var product = products[key];
        var card = element("article", "ls-hsf__product-card");
        card.appendChild(element("p", "ls-hsf__product-kicker", "Suggested for " + Array.from(new Set(matchedRooms)).join(", ")));
        card.appendChild(element("h3", "", product.title));
        card.appendChild(element("p", "", productReason(key, roomLabels, preferenceLabels)));
        var link = element("a", "ls-hsf__product-link", product.link + " →");
        link.href = productUrl(product.href);
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        card.appendChild(link);
        recommendations.appendChild(card);
      });

      renderSummary();
      updateWhatsAppLink(roomLabels, preferenceLabels, Array.from(byProduct.keys()));
    }

    function renderLeadSummary() {
      if (!leadSummary) return;
      leadSummary.innerHTML = "";
      var selectedRooms = selectedValues(state.selectedRooms, roomNames);
      var selectedPreferences = selectedValues(state.selectedPreferences, preferenceNames);
      var productLabels = state.recommendedProducts.map(function (key) { return products[key].title; });
      [
        ["Postal code and property", currentAddressSummary()],
        ["Home type", formatHomeSummary(state.selectedHome)],
        ["Rooms", selectedRooms.join(", ")],
        ["Suggested products", productLabels.join(", ")],
        ["Priorities", selectedPreferences.join(", ") || "Not specified"]
      ].forEach(function (item) {
        var cell = element("div", "ls-hsf__summary-item");
        cell.appendChild(element("small", "", item[0]));
        cell.appendChild(element("strong", "", item[1] || "Not selected"));
        leadSummary.appendChild(cell);
      });
    }

    function leadSelectionText() {
      var record = state.currentRecord;
      var plan = state.selectedHome && state.selectedHome.plan;
      var rooms = selectedValues(state.selectedRooms, roomNames);
      var priorities = selectedValues(state.selectedPreferences, preferenceNames);
      var productLabels = state.recommendedProducts.map(function (key) { return products[key].title; });
      var lines = [
        "Longshade home shade finder request",
        "Postal code: " + (record ? record.postalCode : "Not provided"),
        "Property: " + (record ? propertyLabel(record) : "Not provided"),
        "Home type: " + formatHomeSummary(state.selectedHome),
        "Rooms: " + (rooms.join(", ") || "Not specified"),
        "Priorities: " + (priorities.join(", ") || "Not specified"),
        "Suggested product categories: " + (productLabels.join(", ") || "Not available")
      ];
      if (plan) {
        lines.push("Selected floor plan: " + (plan.unitType || plan.label || "Verified layout"));
        if (plan.floorAreaSqm) lines.push("Floor area: " + plan.floorAreaSqm + " sqm");
        if (plan.floorAreaSqft) lines.push("Floor area: " + plan.floorAreaSqft + " sqft");
        if (plan.sourceUrl) lines.push("Floor-plan source: " + plan.sourceUrl);
      } else if (state.selectedHome && state.selectedHome.detail) {
        lines.push("Home type note: " + state.selectedHome.detail);
      }
      return lines.join("\n");
    }

    function fieldLabelText(field) {
      var labels = [];
      if (field.labels) {
        Array.prototype.forEach.call(field.labels, function (label) { labels.push(label.textContent || ""); });
      }
      if (field.getAttribute("aria-label")) labels.push(field.getAttribute("aria-label"));
      var labelledBy = (field.getAttribute("aria-labelledby") || "").split(/\s+/).filter(Boolean);
      labelledBy.forEach(function (id) {
        var label = document.getElementById(id);
        if (label) labels.push(label.textContent || "");
      });
      if (field.id) {
        qa("label[for]").forEach(function (label) {
          if (label.htmlFor === field.id) labels.push(label.textContent || "");
        });
      }
      var wrappingLabel = field.closest("label");
      if (wrappingLabel) labels.push(wrappingLabel.textContent || "");
      return labels.join(" ").toLowerCase().replace(/\s+/g, " ").trim();
    }

    function syncSelectionField() {
      if (!leadFormHost || !state.currentRecord || !state.selectedHome || !state.selectedRooms.size) return;
      var details = leadSelectionText();
      var fields = leadFormHost.querySelectorAll("textarea, input:not([type]), input[type='text']");
      Array.prototype.forEach.call(fields, function (field) {
        if (!/shade finder selections|home shade finder selections/.test(fieldLabelText(field))) return;
        if (field.value === details) return;
        field.value = details;
        field.dispatchEvent(new Event("input", { bubbles: true }));
        field.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }

    function updateWhatsAppLink(roomLabels, preferenceLabels, productKeys) {
      var phone = String(root.dataset.whatsappPhone || "6593895689").replace(/[^0-9]/g, "");
      var record = state.currentRecord;
      var message = [
        "Hello Longshade, I would like product advice and a home measurement.",
        "Postal code: " + (record ? record.postalCode : ""),
        "Property: " + (record ? propertyLabel(record) : ""),
        "Home type: " + formatHomeSummary(state.selectedHome),
        "Rooms: " + roomLabels.join(", "),
        "Priorities: " + (preferenceLabels.length ? preferenceLabels.join(", ") : "Not specified"),
        "Suggested product categories: " + productKeys.map(function (key) { return products[key].title; }).join(", "),
        "Please help confirm suitable products and arrange a no-obligation measurement."
      ].join("\n");
      var href = "https://api.whatsapp.com/send?phone=" + phone + "&text=" + encodeURIComponent(message);
      whatsappLinks.forEach(function (link) { link.href = href; });
    }

    qa("[data-hsf-example]").forEach(function (exampleButton) {
      exampleButton.addEventListener("click", function (event) {
        postalInput.value = event.currentTarget.dataset.exampleCode || "018965";
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
      });
    });

    form.addEventListener("submit", search);
    if (leadContactForm && !q("[data-hsf-posted-success]")) {
      leadContactForm.addEventListener("submit", function (event) {
        if (leadContactForm.dataset.hsfSubmitting === "true") {
          event.preventDefault();
          return;
        }
        leadContactForm.dataset.hsfSubmitting = "true";
        if (leadSubmitButton) {
          leadSubmitButton.disabled = true;
          leadSubmitButton.setAttribute("aria-busy", "true");
        }
        if (leadSubmitLabel) leadSubmitLabel.textContent = "Sending your request…";
        if (leadSubmitStatus) {
          leadSubmitStatus.textContent = "Sending your request to Longshade. Please keep this page open; confirmation or any issue will appear here.";
          window.setTimeout(function () {
            if (leadSubmitStatus.isConnected && !document.hidden) {
              leadSubmitStatus.textContent = "This is taking longer than usual. Shopify has not confirmed the request yet. Please keep this page open and avoid submitting again.";
            }
          }, 12000);
        }
      });
    }
    propertySelect.addEventListener("change", function () {
      var record = state.currentRecords[Number(propertySelect.value)];
      if (record) showRecord(record);
      setStatus("Building selected. Continue to choose your home type.", false);
    });
    hdbCheck.addEventListener("change", function () {
      startButton.disabled = !hdbCheck.checked;
      if (hdbCheck.checked) setStatus("HDB block confirmed. Continue to choose your flat type.", false);
    });
    startButton.addEventListener("click", function () {
      if (!state.currentRecord) return;
      if (state.currentRecord.type === "HDB" && !hdbCheck.checked) {
        setStatus("Please confirm this is the HDB block where you live.", true);
        hdbCheck.focus();
        return;
      }
      renderHomeTypes();
      showStep(2, true);
    });
    q("[data-hsf-continue-manual]").addEventListener("click", continueManually);

    qa("[data-hsf-room-choice], [data-hsf-preference]").forEach(function (input) {
      input.addEventListener("change", syncChoiceLabels);
    });

    qa("[data-hsf-next]").forEach(function (button) {
      button.addEventListener("click", function () {
        var next = Number(button.dataset.hsfNext);
        if (next === 3 && !state.selectedHome) {
          setValidation(homeValidation, "Choose the closest home type before continuing.", true);
          return;
        }
        if (next === 4 && state.selectedRooms.size === 0) {
          setValidation(roomValidation, "Select at least one room before viewing suggestions.", true);
          return;
        }
        if (next === 4) renderRecommendations();
        if (next === 5 && (!state.selectedHome || state.selectedRooms.size === 0)) {
          setValidation(roomValidation, "Choose your home type and at least one room before sending your request.", true);
          showStep(state.selectedHome ? 3 : 2, true);
          return;
        }
        showStep(next, true);
      });
    });

    qa("[data-hsf-go-step]").forEach(function (button) {
      button.addEventListener("click", function () {
        showStep(Number(button.dataset.hsfGoStep), true);
      });
    });

    var contactUrl = safeUrl(root.dataset.contactUrl || "/pages/schedule-consultation", true);
    contactLinks.forEach(function (link) {
      if (contactUrl) link.href = contactUrl;
    });

    postalInput.addEventListener("input", function () {
      if (state.currentCode && postalInput.value.trim() !== state.currentCode) {
        state.currentRecord = null;
        state.currentRecords = [];
          state.currentCode = "";
        state.selectedHome = null;
          resetRoomSelections();
        matchCard.hidden = true;
        noMatch.hidden = true;
        matchActions.hidden = true;
        propertyWrap.hidden = true;
        addressChips.forEach(function (chip) { chip.textContent = ""; });
        setStatus("", false);
        showStep(1, false);
      }
    });

    setStepInitial();

    if (leadFormHost && window.MutationObserver) {
      var leadFormObserver = new MutationObserver(syncSelectionField);
      leadFormObserver.observe(leadFormHost, { childList: true, subtree: true });
    }
    if (previewForm) {
      previewForm.addEventListener("submit", function (event) {
        event.preventDefault();
        var previewStatus = q("[data-hsf-preview-status]");
        if (previewStatus) previewStatus.textContent = "本地预览已完成验证；资料未发送，也未写入 Shopify。";
      });
    }

    function setStepInitial() {
      var submissionResult = q("[data-hsf-posted-success], [data-hsf-submission-error]");
      showStep(submissionResult ? 5 : 1, false);
      syncChoiceLabels();
      if (submissionResult) {
        submissionResult.focus({ preventScroll: true });
        window.requestAnimationFrame(function () {
          submissionResult.scrollIntoView({ behavior: "auto", block: "center" });
        });
      }
    }
  }
})();
/* 20261016 hdb check step removed: the HDB block confirmation checkbox step was removed per user request - flow now goes postal match -> (building select) -> choose home type directly. */
